import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit'

type AlertVariant = 'success' | 'error' | 'info' | 'warning'

interface AlertSchema {
  id: string
  message: string
  variant: AlertVariant
  expiresAfter: number
}

interface AlertState {
  items: AlertSchema[]
}

const initialState: AlertState = {
  items: [],
}

export const AlertSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert: (state, action: PayloadAction<Omit<AlertSchema, 'id'>>) => {
      state.items.push({ ...action.payload, id: nanoid() })
    },
    removeAlert: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload)
    },
  },
})

export const { addAlert, removeAlert } = AlertSlice.actions

export default AlertSlice.reducer
